import store from '@/store';

export default (to, from, next) => ({
  allow: store.getters.is_account,
  redirect: { name: 'sign-in' },
});
